import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
@Component({
  templateUrl: 'behalf-declaration.html'
})
export class BehalfDeclarationPopover implements OnInit{
  checkPep:boolean = true;
  popOverContent: any;

  constructor(
    public popoverController: PopoverController,
    public navigator:Navigator
    // public logger:Logger
    ) {
    // this.logger.log(this.viewCtrl.data);
  }
  ngOnInit(){
    this.popOverContent= this.navigator.activePopovers[this.navigator.activePopovers.length-1].componentProps.data;
  }

  closePopover(response:string) {
    this.popoverController.dismiss(response);
  }
  onClose = () => {
    this.popoverController.dismiss();
  }
}